import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Button';

import './Paginator.scss';

class Paginator extends Component {
  constructor(props) {
    super(props);

    const pageInput = props.totalPages === 0 ? 0 : this.props.currentPage;

    this.state = {
      backspacePressed: false,
      nextDisabled: props.currentPage >= props.totalPages,
      prevDisabled: props.currentPage === 1,
      blurredValue: props.currentPage,
      isDisabled: props.totalPages < 2,
      onChange: false,
      pageInput,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { currentPage, totalPages } = nextProps;
    if (this.props.currentPage !== currentPage ||
      this.props.totalPages !== totalPages) {
      this.setState({
        currentPage,
        isDisabled: totalPages < 2,
        nextDisabled: currentPage >= totalPages,
        pageInput: currentPage,
        prevDisabled: parseInt(currentPage, 10) <= 1,
      });
    }
  }

  onChange = (event) => {
    const value = parseInt(event.target.value, 10)
      ? event.target.value
      : 1;
    this.setState({
      pageInput: value,
    });
  };

  onBlur = (event) => {
    const newValue = +(event.target.value); // unary plus operator converts string to number
    if (newValue >= 1 && newValue <= this.props.totalPages) {
      this.setState({
        isDisabled: this.props.totalPages === 1,
        pageInput: newValue,
      }, () => {
        this.props.pageHandler(newValue);
      });
    } else {
      this.setState({
        isDisabled: this.props.totalPages === 1,
        pageInput: this.props.currentPage,
      });
    }
  }

  checkKey = (event) => {
    const keyCode = event.charCode || event.which;
    if (keyCode === 13 &&
      this.state.pageInput !== this.props.currentPage) {
      this.props.pageHandler(+(this.state.pageInput)); // unary plus operator converts string to number
    }
  };

  render() {
    return (
      <div className="paginator">
        <Button
          id={(this.props.isrelatedSearchLoaded === true? `${this.props.id}_btn_prev CaseLandingGrid` : (this.props.tableCss === "tableAppSearch"? `${this.props.id}_btn_prev CaseLandingGrid`: `${this.props.id}_btn_prev`))}
          height = {30}
          action={() => this.props.pageHandler(+(this.props.currentPage) - 1)}
          category="hollow"
          extraClass="paginator__prev paginator__Btn paginator__prevBtn"
          disabled={this.state.isDisabled || this.state.prevDisabled}
        >
          {this.props.translations.prev}
          
        </Button>
        <span>{this.props.translations.page}</span>
        {this.state.isDisabled ? <span>&nbsp;{this.props.totalPages === 0 ? 0 : this.state.pageInput}&nbsp;</span>
          : <input
            id={(this.props.isrelatedSearchLoaded === true? `${this.props.id}_textBox_pageInput CaseLandingGrid` : (this.props.tableCss === "tableAppSearch"? `${this.props.id}_textBox_pageInput CaseLandingGrid`: `${this.props.id}_textBox_pageInput`))}
            onBlur={this.onBlur}
            className="paginator__input field-input"
            onChange={this.onChange}
            onKeyPress={this.checkKey}
            type="text"
            value={this.state.pageInput}
            disabled={this.state.isDisabled}
          />}
        <span>{this.props.translations.preposition} {this.props.totalPages}</span>
        <Button
          id={(this.props.isrelatedSearchLoaded === true? `${this.props.id}_btn_next CaseLandingGrid` : (this.props.tableCss === "tableAppSearch"? `${this.props.id}_btn_next CaseLandingGrid`: `${this.props.id}_btn_next`))}
          action={() => this.props.pageHandler(+(this.props.currentPage) + 1)}
          category="hollow"
          extraClass="paginator__next paginator__Btn"
          disabled={this.state.isDisabled || this.state.nextDisabled}
        >
          {this.props.translations.next}
        </Button>
      </div>
    );
  }
}

Paginator.propTypes = {
  currentPage: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  pageHandler: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  translations: PropTypes.object.isRequired,
  id: PropTypes.string,
};

Paginator.defaultProps = {
  extraClass: '',
  id: '',
};

export default Paginator;
